import type { ParseParams, ZodSchema } from "zod";

import { useCallback } from "react";

/**
 * https://github.com/Glazy/formik-validator-zod
 * Allows you to easily use Zod schemas with the <Formik /> component `validate`
 * prop.
 *
 * ```js
 * <Formik {...} validate={withZodSchema(yourSchema)}>
 * ```
 */
export const useM365PulseFormValidate = <T>({ schema, params }: { schema: ZodSchema<T>; params?: Partial<ParseParams> }) =>
    useCallback<(values: T) => Partial<T>>(
        (values: T) => {
            const result = schema.safeParse(values, params);
            if (result.success) {
                return {};
            }
            return result.error.issues.reduce((acc, curr) => {
                const key = curr.path.join(".");
                return {
                    ...acc,
                    [key]: curr.message
                };
            }, {});
        },
        [params, schema]
    );
